(ns ui.view.survey.full-grid
  (:require
   [common.localization :as loc]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [frontend.view.components.upload :as upload]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.view.survey.components :as components]
   [ui.view.survey.event :as event]
   [ui.view.survey.modals.confirm-overwrite-answers :as overwrite-existing-answers-modal]
   [ui.view.survey.modals.confirm-remove-column :as confirm-remove-row-modal]
   [ui.view.survey.modals.confirm-submit :as confirm-submit-modal]
   [ui.view.survey.modals.loading-excel :as loading-excel-modal]
   [ui.view.survey.modals.mandatory-missing :as mandatory-missing-modal]
   [ui.view.survey.modals.missing-sheets :as missing-sheets-modal]
   [ui.view.survey.modals.num-fmt-select :as num-fmt-modal]
   [ui.view.survey.modals.resolve-errors :as resolve-errors-modal]
   [ui.view.survey.modals.select-sheet :as select-sheet-modal]
   [ui.view.survey.modals.tesi-esg-errors :as tesi-errors-modal]
   [ui.view.survey.sub :as sub]))

(defn main-header
  [survey-id lang]
  (let [hero-img-url @(rf/subscribe [::sub/hero-img-url survey-id])
        survey-label @(rf/subscribe [::sub/survey-label-display survey-id])]
    [:div
     {:class "py-3 flex items-center shrink-0 grow-0 gap-4 justify-items-stretch"}
     (when hero-img-url
       [:img
        {:class "max-h-[40px] mx-2"
         :src   hero-img-url}])
     [:div
      {:class (fu/cs "text-[26px] font-bold flex-auto text-base-light-text-accent")}
      survey-label]
     [:div
      {:class "flex items-center flex-auto justify-end gap-2"}
      [components/tesi-fund-excel-block survey-id]
      [button/secondary-open
       {:on-click (fn [_]
                    (rf/dispatch [::event/change-form-style survey-id :survey-form.style/grid]))}
       ^{:key (str "compress-icon-" survey-id)}
       [:i.fal.fa-compress-alt]]]]))

(defn second-header
  [survey-id lang]
  (let [target-name @(rf/subscribe [::sub/target-name-if-not-in-label survey-id])
        numeric-questions? @(rf/subscribe [::sub/numeric-questions? survey-id])]
    [:div
     {:class "pl-2 flex items-center shrink-0 grow-0 gap-2 justify-items-stretch"}
     (if target-name
       [:div
        {:class "flex-auto font-bold pl-4"}
        target-name]
       [components/reporting-period-text survey-id lang])
     [:div
      {:class "flex items-center flex-auto justify-end gap-5"}
      (when target-name
        [components/reporting-period-text survey-id lang])
      [components/lang-selector survey-id lang]
      (when numeric-questions?
        [:div
         {:class-name "hidden md:flex"}
         [components/thousand-separator]])
      (when numeric-questions?
        [:div
         {:class-name "hidden md:flex"}
         [components/decimal-separator]])

      [components/add-remove-columns-buttons true survey-id lang]]]))

(defn full-screen-header
  [survey-id]
  (let [lang @(rf/subscribe [::sub/selected-lang survey-id])]
    [:<>
     [main-header survey-id lang]
     [second-header survey-id lang]]))

(defn grid-2
  [survey-id]
  [components/ag-grid
   {:survey-id            survey-id
    :question-min-width   240
    :col-series-min-width 200}])

(defn full-body
  [survey-id]
  (let [validate-counter @(rf/subscribe [::sub/validate-counter survey-id])]
    [:div
     {:class (fu/cs "pt-2 flex flex-col flex-auto max-h-full gap-2 max-w-full overflow-hidden")}
     [:div
      {:class "h-screen flex flex-auto *:w-full"}
      ^{:key (str "survey-validate-" validate-counter)}
      [grid-2 survey-id]]]))

(defn view
  [survey-id]
  [:div
   {:class (fu/cs "bg-complement-light text-complement-light-text"
                  "flex flex-auto flex-col"
                  "mx-auto gap-2 px-2 pt-2 w-full"
                  "overflow-hidden")}
   [full-screen-header survey-id]
   [full-body survey-id]
   ;; modals & off-screen
   [select-sheet-modal/view]
   [resolve-errors-modal/view]
   [tesi-errors-modal/view]
   [missing-sheets-modal/view]
   [overwrite-existing-answers-modal/view]
   [confirm-remove-row-modal/view]
   [confirm-submit-modal/view]
   [num-fmt-modal/view]
   [loading-excel-modal/view survey-id]
   [mandatory-missing-modal/view survey-id]])
